import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PagedEntitiesGrid from '../../common/components/PagedEntitiesGrid';
import Card from '../../common/components/Card';
import { withNamespaces } from 'react-i18next';
import moment from 'moment';

const Grid = ({ t, ...rest }) => {
    const renderItem = item => {

        return <Card key={item.id} color='orange' style={{ marginBottom: 15 }}>
            <div>
                <div>
                    <h4>{item.center && item.center.name}</h4>
                    <h4 className='text-muted'>{item.workshop}</h4>
                </div>
            </div>
            <div style={{ fontSize: 20, marginTop: 10, marginBottom: 10 }} className='grade-link'>{item.child && item.child.shortName}</div>
            <div style={{ position: 'relative' }}>
                <div className='text-muted'>
                    <div>{t('FO_Payment_Created')}</div>
                    <div>{moment(item.created).format('lll')}</div>
                </div>
                <div style={{ position: 'absolute', bottom: 0, right: 0 }}><Link to={`/workshop-enrolments/${item.id}`}>{t('FO_Payment_Details')}</Link></div>
            </div>
        </Card>;
    }

    return <PagedEntitiesGrid itemsPerRow={1} itemComponent={renderItem} {...rest} />;
};

Grid.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        child: PropTypes.shape({
            shortName: PropTypes.string
        }),
        center: PropTypes.shape({
            name: PropTypes.string
        }),
        startDate: PropTypes.string,
        created: PropTypes.string
    }))
};

export default withNamespaces()(Grid);